import React, { FunctionComponent, useState } from 'react';
import { Button } from '../../../ui';
import { useAccount } from '../../../../hooks/useAccount';
import { BriefKeywordInput } from '../../../../services/models/brief-creation-request';
import CreateBriefKeyword from '../create-brief-keyword/CreateBriefKeyword';

interface Props {
  active: boolean;
  showCancelAction: boolean;
  onComplete: (keywords: BriefKeywordInput[]) => void;
}

const DefineBriefStep: FunctionComponent<Props> = ({ active, showCancelAction, onComplete }) => {
  const { account } = useAccount();
  const maxTopics = account?.product?.features.keywordsPerBrief || 0;
  const [keywords, setKeywords] = useState<BriefKeywordInput[]>([]);
  const [emptyTopics, setEmptyTopics] = useState(true);

  const getKeywordInputControl = () => {
    return (
      <CreateBriefKeyword
        maxItems={maxTopics}
        keywords={keywords}
        update={keywords => {
          setKeywords(keywords);
          setEmptyTopics(keywords.length === 0);
        }}
      />
    );
  };

  if (!active) {
    return <></>;
  }

  return (
    <div className="mx-auto w-full max-w-2xl px-4 text-base">
      <div className="mx-auto max-w-xl">
        <p className="mt-8 leading-relaxed text-gray-700">
          <strong>Tip.</strong> It works best to focus the keywords on a single topic, use many
          different words to describe it. You can always create more briefs dedicated to specific
          topics.
        </p>
      </div>
      <div className="mx-auto mt-6 max-w-xl">{getKeywordInputControl()}</div>
      <div className="mx-auto mt-5 flex max-w-xl items-end justify-end gap-4 pb-5">
        {showCancelAction && (
          <Button
            variant="light"
            onClick={() => {
              window.history.back();
            }}
          >
            Cancel
          </Button>
        )}
        <Button disabled={emptyTopics} variant="purple" onClick={() => onComplete(keywords)}>
          Next
        </Button>
      </div>
    </div>
  );
};

export default DefineBriefStep;
